/**
 * Created by Ray on 2016/12/27.
 */
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {Constants} from '../constants';
import {HttpService} from './http.service';
import {MsgService} from "./message.service";

@Injectable()
export class AuthService {

    public redirectUrl:string;

    constructor(private constants:Constants, private http:HttpService, private msgService:MsgService, private router:Router) {
    }

    login(loginId:string, pwd:string, callback?:Function, errorback?:Function) {
        const param = {
            loginId: loginId,
            pwd: pwd
        };
        this.http.post('auth/login', param, data => {
            const user = data;
            if (user && user.token) {
                localStorage.setItem(this.constants.local_storage_login_user, JSON.stringify(user));
                localStorage.setItem(this.constants.local_storage_login_date, Date.now().toString());
                localStorage.setItem(this.constants.local_storage_token_name, user.token);
                localStorage.setItem(this.constants.local_storage_expire_date,
                    (Date.now() + this.constants.option_keep_login_time).toString());
            }
            this.redirectUrl = this.getDefaultUrl();
            callback(data);
        }, errorback);
    }

    checkLogin(callback:Function) {
        const userStr = localStorage.getItem(this.constants.local_storage_login_user);
        const ExpDate = localStorage.getItem(this.constants.local_storage_expire_date);

        if (userStr && ExpDate > Date.now().toString()) {
            const user = JSON.parse(userStr);
            const param = {
                loginId: user.loginId,
                token: user.token
            };

            this.http.post('auth/isLogin', param, data => {
                callback(data.isLogin);
                if (!data.isLogin) {
                    this.logout();
                }
            }, error => {
                callback(false);
                this.logout();
            });
        } else {
            callback(false);
        }
    }

    isLogin() {
        const user = localStorage.getItem(this.constants.local_storage_login_user);
        const ExpDate = localStorage.getItem(this.constants.local_storage_expire_date);

        if (user && ExpDate > Date.now().toString()) {
            return true;
        } else {
            return false;
        }
    }

    getLogin() {
        return JSON.parse(localStorage.getItem(this.constants.local_storage_login_user));
    }

    logout() {
        localStorage.removeItem(this.constants.local_storage_login_user);
        localStorage.removeItem(this.constants.local_storage_login_date);
        localStorage.removeItem(this.constants.local_storage_expire_date);

        this.router.navigate(['/login']);
    }

    getDefaultUrl():string {
        let url:string;
        if (this.isLogin()) {
            const user = this.getLogin();
            if (user.userType === this.constants.user_type_internal) {
                if (this.hasRole(this.constants.admin_module_permission)) {
                    url = '/admin'
                } else {
                    url = '/error'
                }
            } else if (user.userType === this.constants.user_type_external) {
                if (this.hasRole(this.constants.amazon_module_permission)) {
                    url = '/amazon'
                }
                else if (this.hasRole(this.constants.slt_guest_permission) || this.hasRole(this.constants.slt_smith_permission)) {
                    url = '/slt'
                }
                else if (this.hasRole(this.constants.dell_module_permission)) {
                    url = '/dell'
                }
                else if (this.hasRole(this.constants.fortinet_module_permission)) {
                    url = '/fortinet'
                }
                else if (this.hasRole(this.constants.fortinet_upload_module_permission)) {
                    url = '/fortinet/upload'
                }
                else if (this.hasRole(this.constants.hp_module_permission)) {
                    url = '/external/inventory/hp'
                }
                else if (this.hasRole(this.constants.inventory_module_permission)) {
                    url = '/external/inventory/list'
                }
                else if (this.hasRole(this.constants.invoice_module_permission)) {
                    url = '/external/invoice'
                }
                else if (this.hasRole(this.constants.sales_module_permission)) {
                    url = '/external/sales'
                }
                else if (this.hasRole(this.constants.seo_module_permission)) {
                    url = '/seo/list'
                }
                else if (this.hasRole(this.constants.demo_module_permission)) {
                    url = '/demo'
                }
                else if (this.hasRole(this.constants.trd_permission)) {
                    url = '/trd'
                }
                else {
                    url = '/error'
                }
            } else {
                url = '/error'
            }
        } else {
            url = '/login'
        }

        return url;
    }

    changePWD(pwd) {
        let user = this.getLogin();
        const param = {
            loginId: user.loginId,
            pwd: pwd
        };

        this.http.auth_post('auth/changePWD', param, value=> {
            if (value.res === 'success') {
                user.password = pwd;
                localStorage.setItem(this.constants.local_storage_login_user, JSON.stringify(user));
                this.msgService.showSuccess('PWD Change Success', 'The password is changed.');
            }
        }, error=> {
            this.msgService.showError('PWD Change Failed', 'Change password failed.');
        });
    }

    hasRole(roleName:string):boolean {
        const user = this.getLogin();
        if (user && user.roles) {
            for (let role of user.roles) {
                if (role.name === roleName) {
                    return true;
                }
            }
        }
        return false;
    }

    hasRoles(roleNames:string[]):boolean {
        for (let role of roleNames) {
            if (this.hasRole(role)) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/service/auth.service.ts